let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("buV4R")).then(() => parcelRequire('g1bVT'));